export enum TravelType {
  HOTELS = "hotels",
  CARS = "cars",
  FLIGHTS = "flights",
}
